// Copyright (c) 2016 Deere & Company

import React, {Component, PropTypes} from 'react';
import SmartFormLink from '../../../shared/components/smart-form-link/smart-form-link';

/* eslint-disable react/prefer-stateless-function */

class RegistrationFormCellRenderer extends Component {

    render() {

        return (
            <div className='registration-form-cell-renderer'>
                {this.props.data.registrationForm &&
                    <SmartFormLink
                        displayText={this.props.value}
                        formName='REGISTRATION'
                        objectId={this.props.value}
                    />
                }
            </div>
        );

    }

}

RegistrationFormCellRenderer.displayName = 'RegistrationFormCellRenderer';
RegistrationFormCellRenderer.propTypes = {
    data: PropTypes.object.isRequired,
    value: PropTypes.string.isRequired
};

export default RegistrationFormCellRenderer;



// WEBPACK FOOTER //
// ./src/reports/shared/report-cell-renderers/registration-form-cell-renderer.js